export class DatetimeBase<T> {
    value: T;
    key: string;
    label: string;
    required: boolean;
    order: number;
    controlType: string;
    cssClass: string;
    maxLength: number;
    datetimeFormat: string;
    datetimeUnit: string;
    separator: string;
    datetime: string;
    hasCalendar: boolean;

    constructor(
        options: {
            value?: T,
            key?: string,
            label?: string,
            required?: boolean,
            order?: number,
            controlType?: string,
            cssClass?: string,
            maxLength?: number,
            datetimeFormat?: string,
            datetimeUnit?: string,
            separator?: string,
            datetime?: string,
            hasCalendar?: boolean,
        } = {}) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.cssClass = options.cssClass || '';
        this.maxLength = options.maxLength === undefined ? 2 : options.maxLength;
        this.datetimeFormat = options.datetimeFormat || '';
        this.datetimeUnit = options.datetimeUnit || '';
        this.separator = options.separator || '';
        this.datetime = options.datetime || '';
        this.hasCalendar = options.hasCalendar || false;
    }
}
